import { render, staticRenderFns } from "./ratingScale.vue?vue&type=template&id=28749580&scoped=true"
import script from "./ratingScale.vue?vue&type=script&lang=js"
export * from "./ratingScale.vue?vue&type=script&lang=js"
import style0 from "./ratingScale.vue?vue&type=style&index=0&id=28749580&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28749580",
  null
  
)

export default component.exports